import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { toggleDrawer } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Components
import Drawer from '../Drawer/Drawer';
import FauxSelect from '../Common/FauxSelect';

const Integrations = observer(class Integrations extends React.Component {
  constructor() {
    super();
    this.selectOption = this.selectOption.bind(this);
    this.complete = this.complete.bind(this);
  }

  componentWillMount() {
    this.state = {
      drawerOpen: false,
      drawerContent: null,
      integrationSid: null
    }

    this.props.store.SettingsStore.getIntegrations();
  }

  componentDidMount() {
    const { action, integrationSid, saved } = this.props.routing.location.query;

    if(integrationSid && action) {
      toggleDrawer(null, this, action);

      this.setState({
        drawerOpen: true,
        drawerContent: action,
        integrationSid
      });
    }

    if(saved) {
      this.complete();
    }
  }

  actions() {
    const { translation } = this.props;

    let actions = [
      {
        title: translation.action_options.oauth.label,
        action: 'OAuth'
      }, {
        title: translation.action_options.roles.label,
        action: 'Roles'
      }, {
        title: translation.action_options.sync.label,
        action: 'Sync'
      }
    ]

    return actions;
  }

  selectOption(e, props) {
    const action = e.target.getAttribute('data-action');
    const drawerContent = action;
    let { pathname } = this.props.routing.location;

    this.setState({
      integrationSid: props.integrationSid
    });

    // Update the URL
    pathname += `?integrationSid=${props.integrationSid}&action=${action}`;
    this.props.routing.push(pathname);

    toggleDrawer(e, this, drawerContent);
  }

  complete() {
    this.props.store.SessionStore.showToaster(this.props.translation.settings_saved, 'success');
  }

  renderResults() {
    const { translation } = this.props;
    const { SessionStore, SettingsStore } = this.props.store;

    if(!SessionStore.loading || SettingsStore.integrations.length > 0) {
      return (
        <table>
          <thead>
            <tr>
              <th id="heading-name" className="subtitle" scope="col">
                {translation.name}
              </th>
              <th id="heading-actions" className="subtitle" scope="col">
                {translation.actions}
              </th>
            </tr>
          </thead>
          <tbody>
            {SettingsStore.integrations.map(
              (integration) => {
                return (
                  <tr key={integration.sid}>
                    <td>
                      {integration.name}
                    </td>
                    <td aria-labelledby="heading-action" className="actions">
                      <FauxSelect
                        default={translation.action_select}
                        options={this.actions()}
                        onClick={this.selectOption}
                        parent={this}
                        skipText={true}
                        integrationSid={integration.sid}
                      />
                    </td>
                  </tr>
                )
              }
            )}
          </tbody>
        </table>
      )
    } else if(!SessionStore.loading && SettingsStore.integrations.length === 0) {
      return (
        <span className="no-results">{translation.no_results}</span>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;

    return (
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>
          </div>
        </header>

        <div className="wrap">
          {this.renderResults()}
        </div>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          integrationSid={this.state.integrationSid}
          complete={this.complete}
          parent={this}
          {...this.props}
        />
      </main>
    )
  }
})

export default translate('Integrations')(Integrations);


// WEBPACK FOOTER //
// ./src/app/components/Integrations/Integrations.js